import { useEffect, useState } from "react";
import { useApi } from "../../api";
import { PageHeader } from "../GenericPage";
import { n0, n2 } from "../../lib/format";
import { HBars } from "../../lib/charts";
import { iso } from "../../lib/dates";
import { Notice, Stat } from "../../lib/ui";

/*
 * Sales dashboard for one day – port of sales_analysis.php (API: /api/sales/daily-dashboard)
 * Previous / next day, totals, units by product, sales and profit by product, margin by product, unusual
 * transactions (profit above 10,000 either way, or a loss).
 */

export default function DailyDashboard() {
  const api = useApi();
  const [day, setDay] = useState(iso(new Date()));
  const [d, setD] = useState(null);
  const [error, setError] = useState(null);
  useEffect(() => { api.get("/api/sales/daily-dashboard", { date: day }).then(setD).catch((e) => setError(e.message)); }, [api, day]);
  const nav = d && (
    <span style={{ display: "flex", gap: ".4rem" }}>
      <button type="button" className="btn" onClick={() => setDay(d.prev)}><i className="fas fa-chevron-left" /> Previous day</button>
      <input type="date" aria-label="Day" value={day} onChange={(e) => setDay(e.target.value)} />
      <button type="button" className="btn" onClick={() => setDay(d.next)}>Next day <i className="fas fa-chevron-right" /></button>
    </span>
  );
  return (
    <main className="pg">
      <PageHeader slug="sales_analysis" actions={nav} />
      <Notice notice={error && { tone: "err", text: error }} />
      {d && (
        <>
          <div className="ui-stats">
            <Stat icon="fa-coins" tone="up" label="Sales" value={n0(d.totals.total_sales)} unit="TZS" />
            <Stat icon="fa-sack-dollar" label="Profit" value={n0(d.totals.total_profit)} unit="TZS" />
            <Stat icon="fa-receipt" tone="muted" label="Transactions" value={n0(d.volume.transaction_count)} />
            <Stat icon="fa-cubes" tone="warn" label="Average units per line" value={n2(d.volume.avg_quantity_sold_per_transaction)} />
          </div>
          <div className="grid2">
            <section className="panel card-pad"><h3>Units sold by product</h3><HBars rows={d.products.map((p) => ({ label: p.product_name, values: [p.total_quantity] }))} names={["Units"]} /></section>
            <section className="panel card-pad"><h3>Sales and profit by product</h3><HBars rows={d.products.map((p) => ({ label: p.product_name, values: [p.total_sales, p.total_profit] }))} names={["Sales", "Profit"]} /></section>
            <section className="panel card-pad"><h3>Profit margin by product (%)</h3><HBars rows={d.products.map((p) => ({ label: p.product_name, values: [p.profit_margin_percent || 0] }))} names={["Margin %"]} /></section>
            <section className="panel card-pad"><h3>Unusual transactions</h3>
              {d.unusual.length === 0 ? <p style={{ color: "var(--muted)", margin: 0 }}>None on this day.</p> : (
                <table className="tbl"><thead><tr><th>Reference</th><th className="num">Sales</th><th className="num">Profit</th></tr></thead>
                  <tbody>{d.unusual.map((u, i) => <tr key={i}><td className="mono">{u.transaction_reference || "–"}</td><td className="num mono">{n2(u.total_sales)}</td>
                    <td className="num mono" style={{ color: u.total_profit < 0 ? "var(--danger)" : "var(--up)" }}>{n2(u.total_profit)}</td></tr>)}</tbody></table>)}
            </section>
          </div>
        </>
      )}
    </main>
  );
}
